module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-card.6c199e37.svg";